import { useState, useEffect } from 'react'

export const useFetchInfoApplication = ({ marvarApi, dispatch, onLogout, Forms }) => {
    const { FormRequestGlobal } = Forms
    const { formState, setFormState } = FormRequestGlobal

    // 2. Para mostrar animación de carga
    const [loadingFetchInfoApplication, setLoadingFetchInfoApplication] = useState(false)

    // 4. Para ejecutar el fetch desde alguna acción
    const [execute, setExecute] = useState(false)
    const executeFetchInfoApplication = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/credits/common/get-application-ID/${formState.idcredito}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if (formState.idcredito > 0) {
            setLoadingFetchInfoApplication(true)
            fetchData()
                .then((resp) => {

                    // Setea en el estado del formulario los datos del registro
                    const { data } = resp

                    setFormState((prevState) => ({
                        ...prevState,
                        idcliente: data.idcliente || 0,
                        idcotizacion: data.idcotizacion || 0,
                        idorigen: data.idorigen || '',
                        credito_fecha: data.credito_fecha || '',
                        credito_dia_pago: data.credito_dia_pago || '',
                        aprobacion_check: data.aprobacion_check || '',
                        aprobacion_fecha: data.aprobacion_fecha || '',
                        costo_papeleria: data.costo_papeleria || '', // Agregar este campo

                    }))
                    setLoadingFetchInfoApplication(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchInfoApplication(false)
                })
        }
    }, [execute, formState.idcredito])

    return { loadingFetchInfoApplication, executeFetchInfoApplication }
}

export const useFetchAllCreditsApplications = ({ marvarApi, dispatch, onLogout }) => {
    const [creditsApplications, setCreditsApplications] = useState([])
    const [loadingFetchCreditsApplications, setLoadingFetchCreditsApplications] = useState(false) //estado para animacion de carga

    const [execute, setExecute] = useState(false)
    const executeFetchAllCreditsApplications = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/credits/legal-managements`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchCreditsApplications(true)
        fetchData()
            .then((resp) => {
                setCreditsApplications(resp.data)
                setLoadingFetchCreditsApplications(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchCreditsApplications(false)
            })
    }, [execute])

    return { creditsApplications, loadingFetchCreditsApplications, executeFetchAllCreditsApplications }

}

export const useFetchInfoQuote = ({ marvarApi, dispatch, onLogout, Forms, Helpers }) => {
    const { FormRequestGlobal } = Forms
    const { formState, setFormState } = FormRequestGlobal

    // Formateador de números
    const numberFormatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        maximumFractionDigits: 2
    });

    // 2. Para mostrar animación de carga
    const [loadingFetchInfoQuote, setLoadingFetchInfoQuote] = useState(false)

    // 4. Para ejecutar el fetch desde alguna acción
    const [execute, setExecute] = useState(false)
    const executeFetchInfoQuote = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/vehicle/common/get-quotes-ID/${formState.idcotizacion}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if (formState.idcotizacion > 0) {
            setLoadingFetchInfoQuote(true)
            fetchData()
                .then((resp) => {

                    // Setea en el estado del formulario los datos del registro
                    const { data } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        idcotizacion: data.idcotizacion || 0,
                        enganche: data.enganche || '',
                        interes: (data.interes * 100) || '',
                        interes_total: data.interes_total || '',
                        plazo: data.plazo || '',
                        plazo_anios: data.plazo_anios || '',

                        monto_venta: numberFormatter.format(data.monto_venta) || '',
                        saldo_financiar: numberFormatter.format(data.saldo_financiar) || '',
                        monto_enganche: numberFormatter.format(data.monto_enganche) || '',
                        gps: numberFormatter.format(data.gps) || '',
                        seguro: numberFormatter.format(data.seguro) || '',
                        otros: numberFormatter.format(data.otros) || '',
                        total_cuota: numberFormatter.format(data.total_cuota) || '',
                        cuota_niv: numberFormatter.format(data.cuota_niv) || '',

                        clean_monto_venta: data.monto_venta || '',
                        clean_saldo_financiar: data.saldo_financiar || '',
                        clean_monto_enganche: data.monto_enganche || '',
                        clean_gps: data.gps || '',
                        clean_seguro: data.seguro || '',
                        clean_otros: data.otros || '',
                        clean_total_cuota: data.total_cuota || '',
                        clean_cuota_niv: data.cuota_niv || '',
                    }))
                    setLoadingFetchInfoQuote(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchInfoQuote(false)
                })
        }
    }, [execute, formState.idcotizacion])

    return { loadingFetchInfoQuote, executeFetchInfoQuote }
}

export const useFetchInfoObservations = ({ marvarApi, dispatch, onLogout, Forms }) => {

    const { FormRequestGlobal: { formState } } = Forms

    const [observations, setObservations] = useState([])
    const [loadingFetchObservations, setLoadingFetchObservations] = useState(false) //estado para animacion de carga

    const [execute, setExecute] = useState(false)
    const executeFetchAllObservations = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        if (formState.idcredito > 0) {
            try {
                const response = await marvarApi.get(`/credits/common/log-vehicle/${formState.idcredito}`)
                return response.data
            } catch (e) {
                console.log(e)
            }
        } else {
            setLoadingFetchObservations(true)
        }

    }

    useEffect(() => {
        setLoadingFetchObservations(true)
        if (formState.idcredito > 0) {
            fetchData()
                .then((resp) => {
                    setObservations(resp)
                    setLoadingFetchObservations(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
        }
    }, [execute, formState.idcredito])

    return { observations, loadingFetchObservations, executeFetchAllObservations }

}

export const useFetchAllCustomers = ({ marvarApi, dispatch, onLogout }) => {

    // 1. Para almacenar los clientes
    const [customers, setCustomers] = useState([])


    // 2. Para ejecutar el fetch desde alguna acción
    const [execute, setExecute] = useState(false)
    const executeFetchAllCustomers = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/credits/common/get-customers`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        fetchData()
            .then((resp) => {

                // Setea en el estado del formulario los datos del registro
                const { data } = resp

                setCustomers(data)
            })
            .catch(e => {
                console.log(e, '________ERROR')
            })
    }, [execute])

    return { customers, executeFetchAllCustomers }
}

export const useFetchAllVehicles = ({ marvarApi, dispatch, onLogout, Forms }) => {

    const { FormRequestGlobal: { formState } } = Forms

    // 1. Para almacenar los clientes
    const [vehicles, setVehicles] = useState([])


    // 2. Para ejecutar el fetch desde alguna acción
    const [execute, setExecute] = useState(false)
    const executeFetchAllVehicles = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/vehicle/common/get-vehicles/${formState.idvehiculo}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        fetchData()
            .then((resp) => {

                // Setea en el estado del formulario los datos del registro
                const { data } = resp
                setVehicles(data)
            })
            .catch(e => {
                console.log(e, '________ERROR')
            })
    }, [execute, formState.idvehiculo])

    return { vehicles, executeFetchAllVehicles }
}

export const useFetchAllQuotes = ({ marvarApi, dispatch, onLogout, Forms }) => {

    const { FormRequestGlobal: { formState } } = Forms

    // 1. Para almacenar los clientes
    const [quotes, setQuotes] = useState([])


    // 2. Para ejecutar el fetch desde alguna acción
    const [execute, setExecute] = useState(false)
    const executeFetchAllQuotes = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/credits/common/get-quotes/${formState.idcotizacion}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        fetchData()
            .then((resp) => {

                // Setea en el estado del formulario los datos del registro
                const { data } = resp

                setQuotes(data)
            })
            .catch(e => {
                console.log(e, '________ERROR')
            })
    }, [execute, formState.idcotizacion])

    return { quotes, executeFetchAllQuotes }
}

export const useFetchAllDeposits = ({ marvarApi, dispatch, onLogout, Forms }) => {
    const [deposits, setDeposits] = useState([])
    const [loadingFetchDeposits, seteLoadingFetchDeposits] = useState(false) //estado para animacion de carga

    const { FormRequestGlobal: { formState } } = Forms


    const [execute, setExecute] = useState(false)
    const executeFetchAllDeposits = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/credits/common/get-deposit/${formState.idcredito}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if (formState.idcredito > 0) {
            seteLoadingFetchDeposits(true)
            fetchData()
                .then((resp) => {
                    setDeposits(resp.data)
                    seteLoadingFetchDeposits(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    seteLoadingFetchDeposits(false)
                })
        }
    }, [execute])

    return { deposits, loadingFetchDeposits, executeFetchAllDeposits }

}

export const useFetchAllCashRegisters = ({ marvarApi, dispatch, onLogout }) => {
    const [cashRegisters, setCashRegisters] = useState([])


    const [execute, setExecute] = useState(false)
    const executeFetchAllCashRegisters = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/caja`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        fetchData()
            .then((resp) => {
                const { data } = resp
                setCashRegisters(data)
            })
            .catch(e => {
                console.log(e, '________ERROR')
            })
    }, [execute])

    return { cashRegisters, executeFetchAllCashRegisters }
}

export const useFetchAllBanks = ({ marvarApi, dispatch, onLogout }) => {
    const [banks, setBanks] = useState([])


    const [execute, setExecute] = useState(false)
    const executeFetchAllBanks = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/banco`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        fetchData()
            .then((resp) => {
                const { data } = resp

                setBanks(data)

            })
            .catch(e => {
                console.log(e, '________ERROR')
            })
    }, [execute])

    return { banks, executeFetchAllBanks }
}


export const useFetchAllFiles = ({ marvarApi, dispatch, onLogout, Forms }) => {
    const { FormRequestGlobal: { formState, setFormState } } = Forms

    // 1. Para mostrar animación de carga
    const [loadingFetchInfoFiles, setLoadingFetchInfoFiles] = useState(false)

    // 4. Para ejecutar el fetch desde alguna acción
    const [execute, setExecute] = useState(0)
    const executeFetchAllFiles = async () => {
        setExecute(currentCount => currentCount + 1)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/credits/common/get-documents/${formState.idcredito}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }



    useEffect(() => {
        if (formState.idcredito > 0) {
            setLoadingFetchInfoFiles(true)
            fetchData()
                .then((resp) => {

                    // Setea en el estado del formulario los datos del registro
                    const { data } = resp

                    setFormState((prevState) => ({
                        ...prevState,
                        files: data
                    }))

                    setLoadingFetchInfoFiles(false)

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchInfoFiles(false)
                })
        }
    }, [execute, formState.idcredito])

    return { loadingFetchInfoFiles, executeFetchAllFiles }
}

export const useFetchInfoDeposit = ({ marvarApi, dispatch, onLogout, Forms }) => {

    // Formateador de números
    const numberFormatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        maximumFractionDigits: 2
    });

    const { FormDeposit: { setFormState } } = Forms

    // 1. Para setear parametros de búsqueda al fetch
    const [paramsToSearch, setParamsToSearch] = useState({})

    // 2. Para ejecutar el fetch desde alguna acción
    const [execute, setExecute] = useState(false)
    const executeFetchInfoDeposit = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/credits/common/get-deposit-by-ID/${paramsToSearch.iddeposit}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if (paramsToSearch.iddeposit > 0) {
            fetchData()
                .then((resp) => {

                    // Setea en el estado del formulario los datos del registro
                    const { data } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        iddeposit: data.iddeposit || '',
                        idcaja: data.idcaja || '',
                        idbanco: data.idbanco || '',
                        boleta_numero: data.boleta_numero || '',
                        boleta_foto_path: data.boleta_foto_path || '',
                        boleta_foto_originalname: data.boleta_foto_originalname || '',
                        aprobacion_referencia_ach: data.aprobacion_referencia_ach || '',
                        aprobacion_observaciones: data.aprobacion_observaciones || '',
                        aprobacion_check: data.aprobacion_check || '',
                        deposito_fecha: data.deposito_fecha || '',
                        deposito_moneda: data.deposito_moneda || '',
                        deposito_observaciones: data.deposito_observaciones || '',
                        deposito_tipo_cambio: data.deposito_tipo_cambio || '',
                        movimiento_tipo: data.movimiento_tipo || '',

                        deposito_monto: numberFormatter.format(data.deposito_monto) || '',
                        deposito_quetzales: numberFormatter.format(data.deposito_quetzal) || '',
                        deposito_dolares: numberFormatter.format(data.deposito_dolares) || '',
                        clean_deposito_monto: data.deposito_monto || '',
                        clean_deposito_quetzales: data.deposito_quetzal || '',
                        clean_deposito_dolares: data.deposito_dolares || '',
                    }))

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
        }
    }, [execute])

    return { setParamsToSearch, executeFetchInfoDeposit }
}

export const useFetchAllCollateral = ({ marvarApi, dispatch, onLogout, Forms }) => {
    const { FormRequestGlobal: { formState } } = Forms


    const [collateral, setCollateral] = useState([])

    // 4. Para ejecutar el fetch desde alguna acción
    const [execute, setExecute] = useState(0)
    const executeFetchCollateral = async () => {
        setExecute(currentCount => currentCount + 1)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/credits/common/get-collateral/${formState.idcredito}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if (formState.idcredito > 0) {
            fetchData()
                .then((resp) => {

                    // Setea en el estado del formulario los datos del registro
                    setCollateral(resp.data)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
        }
    }, [execute, formState.idcredito])

    return { collateral, executeFetchCollateral }
}

export const useFetchInfoCollateral = ({ marvarApi, dispatch, onLogout, Forms }) => {

    // Formateador de números
    const numberFormatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        maximumFractionDigits: 2
    });

    const { FormCollateral: { setFormState }, FormRequestGlobal: { formState } } = Forms

    const [paramsToSearch, setParamsToSearch] = useState({})

    // 4. Para ejecutar el fetch desde alguna acción
    const [execute, setExecute] = useState(false)
    const executeFetchCollateral = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/credits/common/get-collateral-ID/${paramsToSearch.idcollateral}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if (paramsToSearch.idcollateral > 0) {
            fetchData()
                .then((resp) => {

                    // Setea en el estado del formulario los datos del registro
                    const { data } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        idvehicledeposit: data.idvehicledeposit || 0,
                        marca: data.marca || '',
                        modelo: data.modelo || '',
                        linea: data.linea || '',
                        color: data.color || '',
                        matricula: data.matricula || '',
                        chasis: data.chasis || '',
                        clean_valor: data.valor || '',
                        valor: numberFormatter.format(data.valor) || '',
                        title: data.title || '',
                        type_collateral: data.type_collateral || '',
                        estate: data.estate || '', 
                        folio: data.folio || '', 
                        department: data.department || '', 
                        book: data.book || '', 
                        description: data.description || '', 
                    }))
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
        }
    }, [execute, paramsToSearch.idcollateral])

    return { setParamsToSearch, executeFetchCollateral }
}
 
export const useFetchCollateralImages = ({ marvarApi, dispatch, onLogout, Forms }) => {
  const { FormCollateral: { formState, onImagesChange } } = Forms;
  const [fetchCount, setFetchCount] = useState(0);

  const executeFetchCollateralImages = () => {
    setFetchCount((prev) => prev + 1);
  };

  const fetchData = async () => {
    const token = localStorage.getItem("token");
    if (!token) return dispatch(onLogout());

    const response = await marvarApi.get(`/credits/collateral/${formState.idcollateral}/images`);
    return response.data;
  };

  useEffect(() => {
    if (formState.idcollateral > 0) {
      fetchData()
        .then((resp) => {
          onImagesChange(resp.data || []);
        })
        .catch((e) => console.error(e, "________ERROR"));
    }
  }, [formState.idcollateral, fetchCount]);

  return { executeFetchCollateralImages };
};

export const useFetchAllOrigins = ({ marvarApi, dispatch, onLogout }) => {

    // 1. Para almacenar los clientes
    const [ dataOrigins, setDataOrigins ] = useState([])
    
    const [ loadingFetchOrigins, setloadingFetchOrigins ] = useState(false)

    // 2. Para ejecutar el fetch desde alguna acción
    const [execute, setExecute] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/credits/common/fetch-origin`)
            // console.log('[useFetchData][useFetchAllOrigins] response.data ::: ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setloadingFetchOrigins(true)
        fetchData()
            .then((resp) => {
                setDataOrigins(resp.rows)
                setloadingFetchOrigins(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setDataOrigins([])
                setloadingFetchOrigins(false)
            })
    }, [execute])

    return { dataOrigins, loadingFetchOrigins, executeFetch }
}